import ImageZoom from '../components/ImageZoom';

let zoomInstance;
const zoomContainer = document.querySelector('.mobile-sidescroll');

document.addEventListener('DOMContentLoaded', function () {
  resetProductPageZoom();
  setMobileGalleryScrollListener();
  setImageModalListener();
});

window.addEventListener('resize', function () {
  resetProductPageZoom();
});

function resetProductPageZoom() {
  // Kill current instance
  if (zoomInstance) {
    zoomInstance.kill();
    zoomInstance = null;
  }
  // Check if is not mobile
  const breakpoint = window.getResponsiveBreakpoint();
  if (breakpoint === 'xs' || breakpoint === 'sm' || breakpoint === 'md') {
    return;
  }
  // Create new instance
  zoomInstance = new ImageZoom(
    document.getElementById('zoom-image-container'),
    {
      fillContainer: true,
      zoomContainer: zoomContainer,
      zoomWidth: 400,
      zoomHeight: 400,
      zoomSrc: document
        .getElementById('zoom_03')
        .getAttribute('data-zoom-image'),
    }
  );
}

// Highlights the n-th dot under the mobile photo gallery
function setMobileGalleryScrollListener() {
  var $scrollGallery = document.querySelector('.mobile-sidescroll');
  var $dots = document.querySelector('.mobile-sidescroll-dots');
  var scrollItemWidth = document.querySelector(
    '.mobile-sidescroll div'
  ).clientWidth;
  $scrollGallery.addEventListener('scroll', function () {
    const index = Math.round($scrollGallery.scrollLeft / scrollItemWidth);

    const $active = $dots.querySelector('div.active');
    if ($active) {
      $active.classList.remove('active');
    }
    $dots
      .querySelector('div:nth-child(' + (index + 1) + ')')
      .classList.add('active');
  });
}

// Open image modal when clicking on main image
function setImageModalListener() {
  const $mainImageContainer = document.querySelector('.mobile-sidescroll');
  const $mainImages = Array.from(document.querySelectorAll('img.grote-foto'));
  const $modal = document.getElementById('enlargeImageModal');
  const modal = new window.bootstrap.Modal($modal);

  const breakpoint = window.getResponsiveBreakpoint();
  if (breakpoint === 'xs' || breakpoint === 'sm' || breakpoint === 'md') {
    // Mobile
    $mainImages.forEach(function ($img) {
      $img.addEventListener('click', function () {
        $modal
          .querySelector('.enlargeImageModalSource')
          .setAttribute('src', $img.getAttribute('src'));
        modal.show();
      });
    });
    return;
  }

  // Not mobile
  $mainImageContainer.addEventListener('click', function () {
    $modal
      .querySelector('.enlargeImageModalSource')
      .setAttribute('src', $mainImages[0].getAttribute('src'));
    modal.show();
  });
}

function changeImageModalPicture(direction) {
  var $thumbs = document.getElementsByClassName('mini-img');
  const $modalImage = document.querySelector('.enlargeImageModalSource');

  if ($thumbs.length < 2) {
    // do nothing
    return;
  }

  for (var i = 0; i < $thumbs.length; i++) {
    if (
      $thumbs[i].getAttribute('data-image') == $modalImage.getAttribute('src')
    ) {
      break;
    }
  }

  if (direction == '-') {
    i -= 1;
    i = i < 0 ? $thumbs.length - 1 : i;
  } else {
    i += 1;
    i = i >= $thumbs.length ? 0 : i;
  }

  var new_img = $thumbs[i].getAttribute('data-zoom-image');
  $modalImage.setAttribute('src', new_img);
}

export { resetProductPageZoom, changeImageModalPicture };
